import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import ExportJsonExcel from "js-export-excel";

function GroupUserSitePublisher() {
  const [groupUserSitePublisherData, setGroupUserSitePublisherData] =
    useState();
  const [campaign, setCampaign] = useState();
  const [advertise, setAdvertise] = useState();

  const params = useParams();
  const groupUserSitePublisherID = params.id;

  useEffect(() => {
    getGroupUserSitePublisherData();
  }, []);

  useEffect(() => {
    if (!groupUserSitePublisherData) {
      return;
    }
    getCampaign();
  }, [groupUserSitePublisherData]);

  useEffect(() => {
    if (!campaign) {
      return;
    }

    getAdvertise();
  }, [campaign]);

  const getAdvertise = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const advertise = await sendRequestGetAdvertise(campaign.cam_id);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!advertise) {
      return;
    }
    setAdvertise(advertise);
  };

  const sendRequestGetAdvertise = async (campaignID) => {
    const headersRequest = getHeaderForRequest();
    let advertise;
    try {
      advertise = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/banner/campaign/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return advertise.data.data;
  };

  const getCampaign = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const campaign = await sendRequestGetCampaign(groupUserSitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!groupUserSitePublisherData) {
      return;
    }
    setCampaign(campaign);
  };

  const sendRequestGetCampaign = async (groupUserSitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let groupUserSitePublisher;
    try {
      groupUserSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/category-user-site-publisher/" +
          groupUserSitePublisherID,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return groupUserSitePublisher.data.data;
  };

  const getGroupUserSitePublisherData = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const groupUserSitePublisherData =
      await sendRequestGetGroupUserSitePublisherData(groupUserSitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!groupUserSitePublisherData) {
      return;
    }
    setGroupUserSitePublisherData(groupUserSitePublisherData);
  };

  const sendRequestGetGroupUserSitePublisherData = async (
    groupUserSitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let groupUserSitePublisher;
    try {
      groupUserSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-user-site-publishers/" +
          groupUserSitePublisherID,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return groupUserSitePublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateGroupUserSitePublisherData = () => {
    return (
      <div>
        <div className="text-left pb-2">
          <Link
            to="/manage/category-user-site-publishers"
            className="btn btn-primary"
          >
            <span className="pl-2">بازگشت</span>
            <span>
              <i className="fa fa-arrow-left"></i>
            </span>
          </Link>
        </div>

        <div className="table-responsive py-2">
          <table className="table table-hilite tbl-td-white-space table-hover m-0  ">
            <thead>
              <tr>
                <td
                  colspan="2"
                  class="text-center"
                  style={{ borderRadius: "25px 25px 0px 0px" }}
                >
                  <b>اطلاعات گروه نمایش دهنده کاربر</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>نام گروه </td>
                <td>{groupUserSitePublisherData.name}</td>
              </tr>
              <tr>
                <td>مبلغ گروه</td>
                <td>
                  <span className="letter-spacing-finance-number pr-1">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(
                        groupUserSitePublisherData.amount
                      )
                    )}
                  </span>
                  <span className="pl-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>شماره کاربر</td>
                <td>
                  <span className="pl-2">
                    {groupUserSitePublisherData?.user_id}
                  </span>
                  <Link
                    target="_blank"
                    to={`/user/show-info-user/${groupUserSitePublisherData?.user_id}`}
                  >
                    <span className="btn btn-primary">نمایش اطلاعات کاربر</span>
                  </Link>
                </td>
              </tr>

              {campaign && (
                <tr>
                  <td>شماره کمپین</td>
                  <td>
                    <span className="pl-2">{campaign.cam_id}</span>
                    <Link
                      target="_blank"
                      to={`/campaigns/manage/banner/simple/view/${campaign.cam_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش اطلاعات کمپین
                      </span>
                    </Link>
                  </td>
                </tr>
              )}
              {advertise && (
                <tr>
                  <td>شماره تبلیغ</td>
                  <td>
                    <span className="pl-2">{campaign.cam_id}</span>
                    <Link
                      target="_blank"
                      to={`/advertise/manage/banner/edit/${advertise.adv_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش اطلاعات تبلیغ
                      </span>
                    </Link>
                  </td>
                </tr>
              )}

              <tr>
                <td>تاریخ شروع</td>
                <td>
                  {helperNumbers.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      groupUserSitePublisherData.start_date
                    )
                  )}
                </td>
              </tr>
              <tr>
                <td>تاریخ پایان</td>
                <td>
                  {helperNumbers.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      groupUserSitePublisherData.end_date
                    )
                  )}
                </td>
              </tr>
              <tr>
                <td>نمایش جایگاه ها بصورت فایل execel</td>
                <td>
                  <div className="btn btn-success" onClick={exportReportExcel}>
                    <span className="pl-2">
                      <i className="fa fa-file-excel-o"></i>
                    </span>
                    <span>خروجی فایل Excel</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>{generateSitePublisherData(groupUserSitePublisherData.sites)}</div>
      </div>
    );
  };

  const calculatePriceSite = (sitePublisherData) => {
    let pricePage = 0;

    for (let pageID in sitePublisherData) {
      if (pageID === "url") {
        continue;
      }
      pricePage += sitePublisherData[pageID].price;
    }
    return pricePage;
  };

  const generateSitePublisherData = (groupUserSitePublisherDataSites) => {
    let tagCollection = [];
    for (const sitePublisherID in groupUserSitePublisherDataSites) {
      const sitePublisherData =
        groupUserSitePublisherDataSites[sitePublisherID];
      tagCollection.push(
        <div className="py-2">
          <div
            className="border border-2 border-warning bg-warning rounded"
            style={{ height: "5px" }}
          ></div>
          <span>سایت : </span>
          <span>
            <a target="_blank" href={sitePublisherData.url}>
              {sitePublisherData.url}
            </a>
          </span>
          <span className="pr-1">-</span>
          <span className="pr-1">قیمت سایت : </span>
          <span className="letter-spacing-finance-number">
            {helperNumbers.toPersianNum(
              helperNumbers.toFormatFinanceNumber(
                calculatePriceSite(sitePublisherData)
              )
            )}
          </span>
          <span className="pr-1"> تومان</span>
        </div>
      );
      for (const sitePublisherID in sitePublisherData) {
        if (sitePublisherID === "url") {
          continue;
        }
        const pageData = sitePublisherData[sitePublisherID];
        tagCollection.push(
          <>
            <div className="d-flex">
              <div>عنوان صفحه : </div>
              <div>{pageData.title}</div>
              <div className="pr-1">-</div>
              <div className="pr-1">قیمت صفحه :</div>
              <div className="letter-spacing-finance-number">
                {helperNumbers.toPersianNum(
                  helperNumbers.toFormatFinanceNumber(pageData.price)
                )}
              </div>
              <div className="pr-1"> تومان</div>
            </div>
            <div className="container-fluid" id="select-position-container">
              <div className="row">
                {generatePositionBox(pageData.positions)}
              </div>
            </div>
          </>
        );
      }
    }
    return tagCollection;
  };

  const generatePositionBox = (positions) => {
    let tagCardPosition = [];
    for (const key in positions) {
      const position = positions[key];

      tagCardPosition.push(
        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2">
          <div className="bg-primary">
            <div className="p-2 d-flex">
              <div className="align-items-center justify-content-center d-flex flex-grow-1 letter-spacing-finance-number">
                {helperNumbers.toPersianNum(position.size)}
              </div>
            </div>

            <div className="px-2 d-flex border-top border-bottom">
              <div className="py-2 w-50 text-center border-left">
                {helperNumbers.toPersianNum(` ${position.count} / 1`)}
              </div>
              <div className="py-2 w-50 text-center letter-spacing-finance-number">
                {helperNumbers.toPersianNum(
                  Math.floor((1 / position.count) * 100)
                )}
                %
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center">
              <span>مبلغ پایه جایگاه :‌</span>
              <span className="letter-spacing-finance-number">
                {helperNumbers.toPersianNum(
                  helperNumbers.toFormatFinanceNumber(position.base_price)
                )}
              </span>
            </div>
            <div dir="ltr" className="p-2 text-center border-top border-bottom">
              <span>مبلغ جایگاه :‌</span>
              <span className="letter-spacing-finance-number">
                {helperNumbers.toPersianNum(
                  helperNumbers.toFormatFinanceNumber(position.price)
                )}
              </span>
            </div>
            <div dir="ltr" className="p-2 text-center">
              {position.tag_html_id}
            </div>
          </div>
        </div>
      );
    }
    return tagCardPosition;
  };

  const exportReportExcel = () => {
    var option = {};
    option.fileName = "گزارش سایت های انتخاب شده";

    let listSites = groupUserSitePublisherData.sites;
    let dataExcelFile = [
      {
        one: "عنوان گروه",
        two: groupUserSitePublisherData.name,
      },
      {
        one: "مبلغ گروه",
        two: helperNumbers.toPersianNum(
          helperNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(listSites)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helperNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            groupUserSitePublisherData.start_date
          )
        ),
        three: "تاریخ پایان",
        four: helperNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            groupUserSitePublisherData.end_date
          )
        ),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];
    for (let key in listSites) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(listSites[key]),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
      {
        sheetData: dataExcelFile,
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherData
  ) => {
    let sitePublisherUrl = sitePublisherData.url;
    delete sitePublisherData.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helperNumbers.toPersianNum(
          helperNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherData)
          )
        ),
      },
    ];

    for (const key in sitePublisherData) {
      const item = sitePublisherData[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }
    return dataEachSitePublisherExcelFile;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const getPriceSitePublisher = (sitePublisherData) => {
    let pricePage = 0;
    const newSitePublisherData = { ...sitePublisherData };
    delete newSitePublisherData.url;
    for (const key in newSitePublisherData) {
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const generatePageDataReportExportExcel = (sitePublisherData) => {
    return [
      {
        one: sitePublisherData.title,
        two: helperNumbers.toPersianNum(
          helperNumbers.toFormatFinanceNumber(sitePublisherData.price)
        ),
      },
      { ...generateTagHtmlID(sitePublisherData.positions) },
      { one: "", two: "" },
    ];
  };

  const generateTagHtmlID = (positions) => {
    return positions.map((item) => item.tag_html_id);
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-category-user-site-publishers"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  نمایش دسته های سایت های نمایش دهنده کاربران
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                {groupUserSitePublisherData !== undefined ? (
                  generateGroupUserSitePublisherData()
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default GroupUserSitePublisher;
